<template>
  <div class="containerTim">
    <header-page :brand="brand"></header-page>

    <div class="top-banner mt-[82px] md:mt-[66px] relative w-full xl:w-[1200px] m-auto">
      <banner-swiper :brand="brand"></banner-swiper>
    </div>
    <div id="section1" class="w-full h-1"></div>
    <div class="container">
      <h1 class="mt-[30px] mb-[-30px] text-[27px] lg:text-[34px] font-bold">iCAUR x ARTY: ACTIVE | CENTRESTAGE 2026</h1>
    </div>
    <form-page ref="formPageRef" :brand="brand" :carList="carList" :btn="btn"></form-page>
    <footer-page :brand="brand" :phone="phone"></footer-page>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue'
import BannerSwiper from '@/components/BannerSwiper.vue'
import FormPage from '@/components/FormPage.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'IcaurView',
  components: {
    HeaderPage,
    BannerSwiper,
    FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      btn: { btnBg: '#f48e30', btnColor: '#111' },
      speak: '中',
      brand: {
        name: 'icaur',
        id: 246,
      },
      phone: '7072 8028',
      // carList: [{ name: 'V23 (RWD)' }, { name: 'V23 (AWD)' }, { name: 'V27' }, { name: 'V9' }],
      carList: [{ name: 'V23 (RWD)' }, { name: 'V23 (AWD)' }, { name: 'V27' }],
    }
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';
.container {
  background-color: #fff;
  width: 92%;
  margin: 0 auto;
  max-width: 1200px;
  h1 {
    font-family: 'icaurFontBold' !important;
  }
}
.containerTim {
  font-family: 'icaurFont', sans-serif !important;
}
::v-deep .el-select-dropdown__item {
  font-family: 'icaurFont', sans-serif !important;
}
::v-deep .el-select-dropdown__item:hover {
  background-color: #f5f5f5;
}
::v-deep .el-select-dropdown__item.selected {
  color: #f48e30;
  font-weight: 600;
}
.top-banner {
  //width: 100%;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
